<script lang="ts">
    import type Vehicles from "@/schemas/public/Vehicles";
    import AppLayout from "@/layouts/AppLayout.svelte";
    import {Plus} from "lucide-svelte";
    import type Blocks from "@/schemas/public/Blocks";
    import type {Field} from "@/types/types";
    import VehicleTable from "@/components/vehicles/VehicleTable.svelte";
    import CreateVehicleModal from "@/components/vehicles/CreateVehicleModal.svelte";
    import CreateRecordModal from "@/components/CreateRecordModal.svelte";

    type Row = Vehicles;

    type StatusOption = {
        value: string;
        label: string;
    };

    type Props = {
        blocks: (Blocks & { fields: Field[] })[];
        statusOptions: StatusOption[];
    };

    let {blocks, statusOptions = []}: Props = $props();

    let breadcrumbs = $state([
        {title: 'Vehicles', href: route('vehicles.index')},
    ]);

    let showCreateVehicleModal = $state(false);

    function openCreateVehicleModal() {
        showCreateVehicleModal = true;
    }

    let view = "index";

    let actionbuttons = $state([
        {
            title: 'Add New Vehicle',
            href: undefined,
            icon: Plus,
            onClick: openCreateVehicleModal,
        },
    ]);

</script>

<svelte:head>
    <title>Vehicles</title>
</svelte:head>

<!--<HeaderActionButtons>-->
<!--    {#if meta.user?.view_type === 'super-admin' || meta.user?.view_type === 'supervisory-body'}-->
<!--        <Button href={route('assessors.create')}>Add New Assessor</Button>-->
<!--    {/if}-->

<!--</HeaderActionButtons>-->
<AppLayout {breadcrumbs} {actionbuttons}>
    <VehicleTable {view} {statusOptions} />
    <CreateVehicleModal
        blocks={blocks}
        bind:show={showCreateVehicleModal}
    />
</AppLayout>
